/**
 * @desc Export table layout configuration.
 * @example
 * import { dimensions } from 'config/dimensions/member-auth-criteria-grid';
 */
export const dimensions = {
    name: 130,
    dob: 130,
    phone: 170,
    memberId: 160,
    rxNumbers: 200,
    address: 220,
    emailId: 200,
    lastCreditCardDigits: 120,
    mfiNumber: 180,
};
